<template>
  <div class="payMentDetails">
    <el-dialog :title="$t('data.split_transaction_detail')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.split_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }} {{ merchantInfo.split_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }} {{ merchantInfo.split_fee | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('components.create_time') }}</span>
        <span class="content-blue">{{ $t('merchantAccount.complete_time') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.transaction_create_time }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.split_transaction_no') }}</span>
        <span class="content-gray">{{ merchantInfo.split_payment_no }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.split_detail_transaction_no') }}</span>
        <span class="content-gray">{{ merchantInfo.detail_no }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.transaction_no') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('data.split_merchant') }}</span>
        <span class="content-gray">{{ merchantInfo.send_merchant_no }}-{{ merchantInfo.send_merchant_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.receiver_type') }}</span>
        <span class="content-gray">{{ getReceiverTypeLabel(merchantInfo.receiver_type) }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.receiver_account') }}</span>
        <span class="content-gray">{{ merchantInfo.receiver_account }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.receiver_name') }}</span>
        <span class="content-gray">{{ merchantInfo.receiver_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.description') }}</span>
        <span class="content-gray">{{ merchantInfo.description }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.fail_reason') }}</span>
        <span class="content-gray">{{ merchantInfo.failed_reason }}</span>
      </div>

      <el-tag :type="getSplitStatusMapType(merchantInfo.split_detail_status)" class="payin-status tag-custom"> {{ getSplitStatusMapLabel(merchantInfo.split_detail_status) }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { GetSplitPaymentOrderDetail } from '@/api/data/data'
import { splitStatusMap, receiverTypeMap } from '@/utils/maps'

export default {
  props: {
    authMerchantNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      merchantInfo: {}
    }
  },
  computed: {
    getReceiverTypeLabel() {
      return function(value) {
        return receiverTypeMap(value).label
      }
    },
    getSplitStatusMapLabel() {
      return function(value) {
        return splitStatusMap(value).label
      }
    },
    getSplitStatusMapType() {
      return function(val) {
        return splitStatusMap(val).type
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo(params) {
      GetSplitPaymentOrderDetail(params).then(res => {
        if (res.code === 10000) {
          this.merchantInfo = res.data
        }
      })
    },
    showModal(data = {}) {
      this.dialogTableVisible = true
      const params = {
        detail_no: data.detail_no
      }
      if (this.authMerchantNo) { // 服务商模式新增字段，用于查询服务商下面授权商户的交易详情
        params.auth_merchant_no = this.authMerchantNo
      }
      this.getDetailInfo(params)
    }
  }
}
</script>
<style>
.payMentDetails .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payMentDetails .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>

<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payMentDetails{
  .payin-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 230px;
  }
}
.mt-12{
  margin-top: 12px;
}
</style>
